export function stripCategoryCode(name) {
  if (!name || typeof name !== "string") {
    return name;
  }

  const separatorIndex = name.indexOf(":");
  return separatorIndex === -1 ? name : name.slice(0, separatorIndex).trim();
}

export function categoryNamesMatch(a, b) {
  return stripCategoryCode(a) === stripCategoryCode(b);
}

export function stripCategoryCodesFromCatalog(categories = []) {
  return categories.map((category) => ({
    ...category,
    category: stripCategoryCode(category.category),
  }));
}

export function stripCategoryCodesFromContent(content = []) {
  let changed = false;

  const next = content.map((section) => {
    if (!section?.deliverableCategory) {
      return section;
    }

    const stripped = stripCategoryCode(section.deliverableCategory);
    if (stripped === section.deliverableCategory) {
      return section;
    }

    changed = true;
    return {
      ...section,
      deliverableCategory: stripped,
    };
  });

  return changed ? next : content;
}
